export const DEFAULT_INTERVAL = 30;
export const SECONDS_IN_MINUTE = 60;
export const MINUTES_IN_HOUR = 60;
export const HOURS_IN_DAY = 24;
export const SECOND = 1000;
export const MINUTE = SECONDS_IN_MINUTE * SECOND;
export const HOUR = MINUTES_IN_HOUR * MINUTE;
export const DAY = HOURS_IN_DAY * HOUR;
export const WEEK_DAY_SUNDAY = 'sunday';
export const WEEK_DAY_MONDAY = 'monday';
export const WEEK_DAY_TUESDAY = 'tuesday';
export const WEEK_DAY_WEDNESDAY = 'wednesday';
export const WEEK_DAY_THURSDAY = 'thursday';
export const WEEK_DAY_FRIDAY = 'friday';
export const WEEK_DAY_SATURDAY = 'saturday';
export const WEEK_DAYS_FULL = [
	WEEK_DAY_SUNDAY,
	WEEK_DAY_MONDAY,
	WEEK_DAY_TUESDAY,
	WEEK_DAY_WEDNESDAY,
	WEEK_DAY_THURSDAY,
	WEEK_DAY_FRIDAY,
	WEEK_DAY_SATURDAY,
];
export const WEEK_DAYS_FULL_I18N_MAP = Object.freeze({
	[WEEK_DAY_SUNDAY]: 'day.full.sunday',
	[WEEK_DAY_MONDAY]: 'day.full.monday',
	[WEEK_DAY_TUESDAY]: 'day.full.tuesday',
	[WEEK_DAY_WEDNESDAY]: 'day.full.wednesday',
	[WEEK_DAY_THURSDAY]: 'day.full.thursday',
	[WEEK_DAY_FRIDAY]: 'day.full.friday',
	[WEEK_DAY_SATURDAY]: 'day.full.saturday',
});
export const WEEK_DAY_SU = 'su';
export const WEEK_DAY_MO = 'mo';
export const WEEK_DAY_TU = 'tu';
export const WEEK_DAY_WE = 'we';
export const WEEK_DAY_TH = 'th';
export const WEEK_DAY_FR = 'fr';
export const WEEK_DAY_SA = 'sa';
export const WEEK_DAYS = Object.freeze([
	WEEK_DAY_SU,
	WEEK_DAY_MO,
	WEEK_DAY_TU,
	WEEK_DAY_WE,
	WEEK_DAY_TH,
	WEEK_DAY_FR,
	WEEK_DAY_SA,
]);
export const WEEK_DAYS_SHORT_I18N_MAP = Object.freeze({
	[WEEK_DAY_SU]: 'day.sunday',
	[WEEK_DAY_MO]: 'day.monday',
	[WEEK_DAY_TU]: 'day.tuesday',
	[WEEK_DAY_WE]: 'day.wednesday',
	[WEEK_DAY_TH]: 'day.thursday',
	[WEEK_DAY_FR]: 'day.friday',
	[WEEK_DAY_SA]: 'day.saturday',
});
export const WEEK_START = WEEK_DAY_MO;
export const MONTH_NAME_JANUARY = 'january';
export const MONTH_NAME_FEBRUARY = 'february';
export const MONTH_NAME_MARCH = 'march';
export const MONTH_NAME_APRIL = 'april';
export const MONTH_NAME_MAY = 'may';
export const MONTH_NAME_JUNE = 'june';
export const MONTH_NAME_JULY = 'july';
export const MONTH_NAME_AUGUST = 'august';
export const MONTH_NAME_SEPTEMBER = 'september';
export const MONTH_NAME_OCTOBER = 'october';
export const MONTH_NAME_NOVEMBER = 'november';
export const MONTH_NAME_DECEMBER = 'december';
export const MONTH_NAMES = Object.freeze([
	MONTH_NAME_JANUARY,
	MONTH_NAME_FEBRUARY,
	MONTH_NAME_MARCH,
	MONTH_NAME_APRIL,
	MONTH_NAME_MAY,
	MONTH_NAME_JUNE,
	MONTH_NAME_JULY,
	MONTH_NAME_AUGUST,
	MONTH_NAME_SEPTEMBER,
	MONTH_NAME_OCTOBER,
	MONTH_NAME_NOVEMBER,
	MONTH_NAME_DECEMBER,
]);

export const DAYS_OF_WEEK_FULL_I18N = [
	'day.full.sunday',
	'day.full.monday',
	'day.full.tuesday',
	'day.full.wednesday',
	'day.full.thursday',
	'day.full.friday',
	'day.full.saturday',
];
export const DAYS_OF_WEEK_MINIMAL_I18N = [
	'month_january_min_with_day',
	'month_february_min_with_day',
	'month_march_min_with_day',
	'month_april_min_with_day',
	'month_may_min_with_day',
	'month_june_min_with_day',
	'month_july_min_with_day',
	'month_august_min_with_day',
	'month_september_min_with_day',
	'month_october_min_with_day',
	'month_november_min_with_day',
	'month_december_min_with_day',
];
export const MONTH_NAMES_I18N_MAP: { [key: string]: string } = Object.freeze({
	[MONTH_NAME_JANUARY]: 'month.january',
	[MONTH_NAME_FEBRUARY]: 'month.february',
	[MONTH_NAME_MARCH]: 'month.march',
	[MONTH_NAME_APRIL]: 'month.april',
	[MONTH_NAME_MAY]: 'month.may',
	[MONTH_NAME_JUNE]: 'month.june',
	[MONTH_NAME_JULY]: 'month.july',
	[MONTH_NAME_AUGUST]: 'month.august',
	[MONTH_NAME_SEPTEMBER]: 'month.september',
	[MONTH_NAME_OCTOBER]: 'month.october',
	[MONTH_NAME_NOVEMBER]: 'month.november',
	[MONTH_NAME_DECEMBER]: 'month.december',
});
export const DAY_LENGTH_IN_MINUTES = 1440;
export const MAX_ORDER_LIFETIME_MINUTES = 5;
